import { render, staticRenderFns } from "./EtitorPage.vue?vue&type=template&id=1632b774&scoped=true&"
import script from "./EtitorPage.vue?vue&type=script&lang=js&"
export * from "./EtitorPage.vue?vue&type=script&lang=js&"
import style0 from "./EtitorPage.vue?vue&type=style&index=0&id=1632b774&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1632b774",
  null
  
)

export default component.exports